<!-- ======= Sidebar ======= -->
<aside id="sidebar" class="sidebar">
  <ul class="sidebar-nav" id="sidebar-nav">
    <ng-container *ngFor="let navItem of SidebarOptions; index as i">
      <li class="nav-heading" *ngIf="false">Pages</li>

      <ng-container *ngIf="navItem.canAccessBy >= sharedService.getUserRole()">
        <li class="nav-item" *ngIf="!navItem.children">
          <a class="nav-link" [routerLink]="[navItem.path]" routerLinkActive="active">
            <i class="bi {{ navItem.icon }}"></i>
            <span>{{ navItem.label }}</span>
          </a>
        </li>
      </ng-container>

      <ng-container *ngIf="navItem.canAccessBy >= sharedService.getUserRole()">
        <li class="nav-item" *ngIf="navItem.children">
          <a class="nav-link collapsed" attr.data-bs-target="#{{ navItem.label }}" data-bs-toggle="collapse" href="javascript:void(0)">
            <i class="bi {{ navItem.icon }}"></i>
            <span>{{ navItem.label }}</span>
            <i class="bi bi-chevron-down ms-auto"></i>
          </a>

          <ul [id]="[navItem.label]" class="nav-content collapse" data-bs-parent="#sidebar-nav">
            <ng-container *ngFor="let subNavItem of navItem.children">
              <ng-container *ngIf="subNavItem.canAccessBy >= sharedService.getUserRole()">
                <li>
                  <a class="nav-link" routerLinkActive="active" [routerLink]="[subNavItem.path]">
                    <i class="bi {{ subNavItem.icon }}"></i><span>{{ subNavItem.label }}</span>
                  </a>
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ng-container>
  </ul>

  <!-- App Footer -->
  <app-footer></app-footer>
</aside>
<!-- End Sidebar-->
